var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.time>1),expression:"this.time>1"}],staticClass:"timerContainer"},[_c('w-icon',{staticClass:"icon",attrs:{"icon":"record","size":"small"}}),_vm._v(" "+_vm._s(_vm.humanTime)+" ")],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }